module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table-responsive content-vertionings table-size"
  }, [_c('table', {
    staticClass: "table table-hover  table-outlined"
  }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.$t("brandadmin.name")))]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.getAllBrands), function(brand) {
    return _c('tr', [_c('td', {
      staticClass: "table-title"
    }, [_vm._v(_vm._s(brand.name ? brand.name.toUpperCase() : ""))]), _vm._v(" "), _c('td', {
      staticClass: "content-action"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.accessFunctionality(brand);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("brandadmin.access")))])])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49650558","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/BrandAdminList.vue
// module id = 3160
// module chunks = 0